import { render, staticRenderFns } from "./TableGenericList.vue?vue&type=template&id=4ef5de5d&"
import script from "./TableGenericList.vue?vue&type=script&lang=js&"
export * from "./TableGenericList.vue?vue&type=script&lang=js&"
import style0 from "./TableGenericList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports